var map = {
	"./gallery-wip-before-paint_00.jpg": 2653,
	"./gallery-wip-before-paint_01.jpg": 2654,
	"./gallery_00.jpg": 2655,
	"./gallery_01.jpg": 2656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2652;